import React from 'react';

import BaseIllustration from './Base';

function ExternalLinkIllustration({ brandingColor, ...rest }) {
  const params = {
    width: 455,
    height: 341,
    ...rest,
  };

  return (
    <BaseIllustration {...params}>
      <path
        d='M390.485 301.096C390.425 297.824 388.37 294.989 385.241 293.85C382.203 292.74 378.538 293.675 376.453 296.129C374.337 298.642 373.95 302.236 375.678 305.041C377.436 307.875 380.773 309.219 384.05 308.664C387.774 308.021 390.425 304.719 390.485 301.096C390.515 299.226 387.535 299.226 387.506 301.096C387.476 303.054 386.195 304.953 384.288 305.567C382.203 306.268 380.028 305.713 378.628 304.047C377.376 302.586 377.227 300.307 378.27 298.613C379.313 296.947 381.428 295.983 383.365 296.363C385.778 296.801 387.446 298.759 387.476 301.096C387.535 302.995 390.515 302.995 390.485 301.096Z'
        fill={brandingColor}
      />
      <path
        d='M368.439 287.042C368.35 280.555 364.238 274.799 358.041 272.52C351.785 270.212 344.367 272.111 340.106 277.166C335.876 282.162 335.22 289.409 338.676 294.989C342.132 300.599 348.895 303.434 355.42 302.294C362.898 300.979 368.35 294.434 368.439 287.042C368.469 285.172 365.489 285.172 365.46 287.042C365.37 292.331 362.004 297.122 356.879 298.876C351.725 300.658 345.856 299.109 342.311 294.989C338.885 290.957 338.468 285.055 341.238 280.555C344.009 276.056 349.55 273.66 354.824 274.624C360.931 275.764 365.37 280.935 365.46 287.013C365.489 288.941 368.469 288.941 368.439 287.042Z'
        fill={brandingColor}
      />
      <g opacity='0.44'>
        <path
          opacity='0.44'
          d='M263.896 77.7773C277.537 77.7773 288.594 67.0634 288.594 53.8472C288.594 40.6309 277.537 29.917 263.896 29.917C250.256 29.917 239.198 40.6309 239.198 53.8472C239.198 67.0634 250.256 77.7773 263.896 77.7773Z'
          fill={brandingColor}
        />
      </g>
      <path
        d='M5 180.89C5 180.89 35.299 247.977 107.456 222.001C74.5655 153.892 5 180.89 5 180.89Z'
        fill={brandingColor}
      />
      <path
        d='M37.7716 146.996C37.7716 146.996 33.8092 193.863 87.6442 224.251L76.3529 178.699L37.7716 146.996Z'
        fill='white'
      />
      <path
        d='M39.142 125.141C39.142 125.141 28.0592 211.365 117.437 228.283C126.553 139.458 39.142 125.141 39.142 125.141Z'
        fill={brandingColor}
      />
      <g filter='url(#filter0_bd_1720_24349)'>
        <path
          d='M405.008 279H93.9925C86.8109 279 81 273.278 81 266.207V70.7929C81 63.7216 86.8109 58 93.9925 58H405.008C412.189 58 418 63.7216 418 70.7929V266.207C417.97 273.278 412.159 279 405.008 279Z'
          fill='url(#paint0_linear_1720_24349)'
          shapeRendering='crispEdges'
        />
      </g>
      <path
        opacity='0.9'
        d='M418.192 91.5101H81.2983V70.9986C81.2983 64.0445 87.0483 58.4053 94.1389 58.4053H405.351C412.442 58.4053 418.192 64.0445 418.192 70.9986V91.5101Z'
        fill={brandingColor}
      />
      <path
        d='M97.8929 77.1053C99.999 77.1053 101.706 75.4309 101.706 73.3653C101.706 71.2998 99.999 69.6253 97.8929 69.6253C95.7867 69.6253 94.0794 71.2998 94.0794 73.3653C94.0794 75.4309 95.7867 77.1053 97.8929 77.1053Z'
        fill='white'
      />
      <path
        d='M113.266 77.1053C115.372 77.1053 117.08 75.4309 117.08 73.3653C117.08 71.2998 115.372 69.6253 113.266 69.6253C111.16 69.6253 109.453 71.2998 109.453 73.3653C109.453 75.4309 111.16 77.1053 113.266 77.1053Z'
        fill='white'
      />
      <path
        d='M128.638 77.1053C130.744 77.1053 132.452 75.4309 132.452 73.3653C132.452 71.2998 130.744 69.6253 128.638 69.6253C126.532 69.6253 124.825 71.2998 124.825 73.3653C124.825 75.4309 126.532 77.1053 128.638 77.1053Z'
        fill='white'
      />
      <g opacity='0.44'>
        <path
          opacity='0.44'
          d='M293.9 29.9528C301.025 29.9528 306.8 24.3669 306.8 17.4764C306.8 10.5859 301.025 5 293.9 5C286.776 5 281 10.5859 281 17.4764C281 24.3669 286.776 29.9528 293.9 29.9528Z'
          fill={brandingColor}
        />
      </g>
      <path d='M142.254 91.5101H81.2983V100.772H142.254V91.5101Z' fill={brandingColor} />
      <path opacity='0.2' d='M418.192 91.5101H142.254V100.772H418.192V91.5101Z' fill={brandingColor} />
      <path
        opacity='0.4'
        d='M391.149 100.772V149.538H269V100.772'
        stroke={brandingColor}
        strokeWidth='1.7'
        strokeMiterlimit='10'
      />
      <path opacity='0.1' d='M247 206H108V279H247V206Z' fill={brandingColor} />
      <path opacity='0.4' d='M386.036 160.444H351V183.176H386.036V160.444Z' fill={brandingColor} />
      <path opacity='0.4' d='M345.036 160.444H310V183.176H345.036V160.444Z' fill={brandingColor} />
      <path opacity='0.4' d='M304.036 160.444H269V183.176H304.036V160.444Z' fill={brandingColor} />
      <path d='M389.213 225.507H269V228.634H389.213V225.507Z' fill={brandingColor} />
      <path d='M389.213 235.296H269V238.422H389.213V235.296Z' fill={brandingColor} />
      <path d='M389.213 245.084H269V248.21H389.213V245.084Z' fill={brandingColor} />
      <path d='M226.716 135.221H106.473V138.348H226.716V135.221Z' fill={brandingColor} />
      <path d='M215.603 145.01H106.473V148.136H215.603V145.01Z' fill={brandingColor} />
      <path d='M358.05 254.872H269V257.998H358.05V254.872Z' fill={brandingColor} />
      <path
        d='M157.746 178.173H114.815C110.048 178.173 106.175 174.374 106.175 169.699C106.175 165.024 110.048 161.226 114.815 161.226H157.746C162.513 161.226 166.386 165.024 166.386 169.699C166.386 174.374 162.513 178.173 157.746 178.173Z'
        fill={brandingColor}
      />
      <path
        d='M106.473 119.56C110.615 119.56 110.615 122.862 114.726 122.862C118.867 122.862 118.867 119.56 123.008 119.56C127.149 119.56 127.149 122.862 131.291 122.862C135.432 122.862 135.432 119.56 139.573 119.56C143.714 119.56 143.714 122.862 147.855 122.862C151.996 122.862 151.996 119.56 156.137 119.56C160.279 119.56 160.279 122.862 164.39 122.862C168.531 122.862 168.531 119.56 172.672 119.56C176.813 119.56 176.813 122.862 180.955 122.862C185.096 122.862 185.096 119.56 189.237 119.56C193.378 119.56 193.378 122.862 197.519 122.862C201.66 122.862 201.66 119.56 205.802 119.56'
        stroke={brandingColor}
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M269 206.544C273.022 206.544 273.022 209.846 277.014 209.846C281.036 209.846 281.036 206.544 285.028 206.544C289.05 206.544 289.05 209.846 293.043 209.846C297.065 209.846 297.065 206.544 301.057 206.544C305.079 206.544 305.079 209.846 309.071 209.846C313.063 209.846 313.063 206.544 317.085 206.544C321.107 206.544 321.107 209.846 325.099 209.846C329.121 209.846 329.121 206.544 333.143 206.544C337.165 206.544 337.165 209.846 341.187 209.846C345.209 209.846 345.209 206.544 349.231 206.544C353.253 206.544 353.253 209.846 357.275 209.846C361.297 209.846 361.297 206.544 365.319 206.544'
        stroke={brandingColor}
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <g filter='url(#filter1_bd_1720_24349)'>
        <path
          d='M185.036 310.534H56.3917C52.9357 310.534 50.1353 307.787 50.1353 304.398V222.527C50.1353 219.138 52.9357 216.391 56.3917 216.391H185.036C188.492 216.391 191.292 219.138 191.292 222.527V304.398C191.292 307.787 188.492 310.534 185.036 310.534Z'
          fill='url(#paint1_linear_1720_24349)'
          shapeRendering='crispEdges'
        />
      </g>
      <path
        d='M191.292 232.345H50.1647V222.498C50.1647 219.138 52.9354 216.45 56.3318 216.45H185.095C188.521 216.45 191.262 219.167 191.262 222.498V232.345H191.292Z'
        fill={brandingColor}
      />
      <path
        d='M58.9237 226.968C60.3717 226.968 61.5455 225.817 61.5455 224.397C61.5455 222.977 60.3717 221.826 58.9237 221.826C57.4758 221.826 56.302 222.977 56.302 224.397C56.302 225.817 57.4758 226.968 58.9237 226.968Z'
        fill='white'
      />
      <path
        d='M69.4704 226.968C70.9183 226.968 72.0921 225.817 72.0921 224.397C72.0921 222.977 70.9183 221.826 69.4704 221.826C68.0224 221.826 66.8486 222.977 66.8486 224.397C66.8486 225.817 68.0224 226.968 69.4704 226.968Z'
        fill='white'
      />
      <path
        d='M80.0169 226.968C81.4649 226.968 82.6387 225.817 82.6387 224.397C82.6387 222.977 81.4649 221.826 80.0169 221.826C78.569 221.826 77.3952 222.977 77.3952 224.397C77.3952 225.817 78.569 226.968 80.0169 226.968Z'
        fill='white'
      />
      <g opacity='0.4' clipPath='url(#clip1_1720_24349)'>
        <path
          d='M365.9 77.33H145.66C143.64 77.33 142 75.69 142 73.66C142 71.64 143.64 70 145.66 70H365.9C367.92 70 369.56 71.64 369.56 73.66C369.56 75.69 367.92 77.33 365.9 77.33Z'
          fill={brandingColor}
        />
      </g>
      <path
        opacity='0.2'
        fillRule='evenodd'
        clipRule='evenodd'
        d='M59.8912 242.272H60.8912H180.24H181.24V243.272V298.846V299.846H180.24H60.8912H59.8912V298.846V243.272V242.272ZM61.8912 244.272V297.846H104.338C115.69 296.476 119.784 291.826 123.952 287.091C127.278 283.314 130.65 279.483 137.792 277.22C137.983 271.446 142.815 266.822 148.749 266.822C152.679 266.822 156.126 268.85 158.062 271.897C160.166 269.748 161.668 266.814 163.192 263.84L163.192 263.839L163.192 263.839L163.192 263.839C163.485 263.266 163.779 262.692 164.079 262.122C167.672 255.326 175.488 251.785 179.24 251.744V244.272H61.8912ZM74.2256 256.073C73.5609 255.231 73.0427 254.612 72 254.612V253.612C73.5576 253.612 74.35 254.616 74.9843 255.42L75.0104 255.453C75.6779 256.299 76.1878 256.914 77.2137 256.914C78.2396 256.914 78.7494 256.299 79.4169 255.453L79.4431 255.42C80.0774 254.616 80.8698 253.612 82.4274 253.612C83.9849 253.612 84.7774 254.616 85.4116 255.42L85.4378 255.453C86.1053 256.299 86.6151 256.914 87.6411 256.914C88.667 256.914 89.1768 256.299 89.8443 255.453L89.8705 255.42C90.5048 254.616 91.2972 253.612 92.8547 253.612C94.4123 253.612 95.2047 254.616 95.839 255.42L95.8652 255.453C96.5327 256.299 97.0425 256.914 98.0684 256.914C99.1111 256.914 99.6293 256.295 100.294 255.453L100.331 255.407C100.96 254.608 101.746 253.612 103.282 253.612C104.84 253.612 105.632 254.616 106.266 255.42L106.293 255.453C106.96 256.299 107.47 256.914 108.496 256.914C109.538 256.914 110.057 256.295 110.721 255.453L110.758 255.407C111.388 254.608 112.174 253.612 113.709 253.612C115.263 253.612 116.055 254.611 116.692 255.413L116.723 255.452C117.392 256.295 117.91 256.914 118.953 256.914C119.996 256.914 120.514 256.295 121.183 255.452L121.214 255.413C121.851 254.611 122.643 253.612 124.196 253.612V254.612C123.153 254.612 122.636 255.231 121.966 256.074L121.935 256.113C121.299 256.915 120.506 257.914 118.953 257.914C117.4 257.914 116.607 256.915 115.971 256.113L115.94 256.074C115.27 255.231 114.752 254.612 113.709 254.612C112.684 254.612 112.174 255.228 111.506 256.073L111.48 256.106C110.846 256.91 110.053 257.914 108.496 257.914C106.96 257.914 106.174 256.918 105.545 256.12L105.508 256.073C104.843 255.231 104.325 254.612 103.282 254.612C102.256 254.612 101.746 255.228 101.079 256.073L101.053 256.106C100.418 256.91 99.626 257.914 98.0684 257.914C96.5325 257.914 95.7468 256.918 95.1172 256.12L95.0803 256.073C94.4156 255.231 93.8974 254.612 92.8547 254.612C91.8121 254.612 91.2938 255.231 90.6292 256.073L90.5923 256.12C89.9627 256.918 89.177 257.914 87.6411 257.914C86.1052 257.914 85.3194 256.918 84.6898 256.12L84.653 256.073C83.9883 255.231 83.47 254.612 82.4274 254.612C81.3847 254.612 80.8665 255.231 80.2018 256.073L80.1649 256.12C79.5353 256.918 78.7496 257.914 77.2137 257.914C75.6778 257.914 74.8921 256.918 74.2625 256.12L74.2625 256.12L74.2256 256.073ZM73.1626 263.492H103.402V265.157H73.1626V263.492ZM103.402 268.225H73.1626V269.891H103.402V268.225ZM73.1626 272.988H93.1832V274.653H73.1626V272.988Z'
        fill={brandingColor}
      />
      <g filter='url(#filter2_bd_1720_24349)'>
        <path
          d='M446.167 125.105H315.676C312.727 125.105 310.373 122.767 310.373 119.904V36.1924C310.373 33.2997 312.756 30.9915 315.676 30.9915H445.691C448.908 30.9915 451.5 33.5335 451.5 36.6891V119.904C451.5 122.767 449.117 125.105 446.167 125.105Z'
          fill={brandingColor}
        />
      </g>
      <path
        opacity='0.2'
        d='M310.373 70.9336C310.373 70.9336 375.678 74.0016 426.415 125.105H315.557C312.697 125.105 310.403 122.826 310.403 120.05V70.9336H310.373Z'
        fill='white'
      />
      <path
        d='M368.366 96.5876V59.509L401.465 78.0629L368.366 96.5876Z'
        stroke='white'
        strokeWidth='2'
        strokeMiterlimit='10'
      />
      <path
        opacity='0.2'
        d='M398.022 30.9916C398.022 30.9916 408.092 61.1745 451.5 64.1841V36.6892C451.5 33.5336 448.908 30.9916 445.69 30.9916H398.022Z'
        fill='white'
      />
      <defs>
        <filter
          id='filter0_bd_1720_24349'
          x='28.5158'
          y='5.51577'
          width='441.968'
          height='332.143'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feGaussianBlur in='BackgroundImage' stdDeviation='26.2421' />
          <feComposite in2='SourceAlpha' operator='in' result='effect1_backgroundBlur_1720_24349' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feMorphology radius='3.08731' operator='erode' in='SourceAlpha' result='effect2_dropShadow_1720_24349' />
          <feOffset dy='15.4365' />
          <feGaussianBlur stdDeviation='23.1548' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0' />
          <feBlend mode='normal' in2='effect1_backgroundBlur_1720_24349' result='effect2_dropShadow_1720_24349' />
          <feBlend mode='normal' in='SourceGraphic' in2='effect2_dropShadow_1720_24349' result='shape' />
        </filter>
        <filter
          id='filter1_bd_1720_24349'
          x='-2.34898'
          y='163.907'
          width='246.125'
          height='205.286'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feGaussianBlur in='BackgroundImage' stdDeviation='26.2421' />
          <feComposite in2='SourceAlpha' operator='in' result='effect1_backgroundBlur_1720_24349' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feMorphology radius='3.08731' operator='erode' in='SourceAlpha' result='effect2_dropShadow_1720_24349' />
          <feOffset dy='15.4365' />
          <feGaussianBlur stdDeviation='23.1548' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0' />
          <feBlend mode='normal' in2='effect1_backgroundBlur_1720_24349' result='effect2_dropShadow_1720_24349' />
          <feBlend mode='normal' in='SourceGraphic' in2='effect2_dropShadow_1720_24349' result='shape' />
        </filter>
        <filter
          id='filter2_bd_1720_24349'
          x='257.889'
          y='-21.4928'
          width='246.095'
          height='205.257'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feGaussianBlur in='BackgroundImage' stdDeviation='26.2421' />
          <feComposite in2='SourceAlpha' operator='in' result='effect1_backgroundBlur_1720_24349' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feMorphology radius='3.08731' operator='erode' in='SourceAlpha' result='effect2_dropShadow_1720_24349' />
          <feOffset dy='15.4365' />
          <feGaussianBlur stdDeviation='23.1548' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0' />
          <feBlend mode='normal' in2='effect1_backgroundBlur_1720_24349' result='effect2_dropShadow_1720_24349' />
          <feBlend mode='normal' in='SourceGraphic' in2='effect2_dropShadow_1720_24349' result='shape' />
        </filter>
        <linearGradient
          id='paint0_linear_1720_24349'
          x1='249.5'
          y1='58'
          x2='249.5'
          y2='279'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0.3' />
          <stop offset='1' stopColor='white' stopOpacity='0.7' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_1720_24349'
          x1='120.714'
          y1='216.391'
          x2='120.714'
          y2='310.534'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0.3' />
          <stop offset='1' stopColor='white' stopOpacity='0.7' />
        </linearGradient>
        <clipPath id='clip0_1720_24349'>
          <rect width='455' height='341' fill='white' />
        </clipPath>
        <clipPath id='clip1_1720_24349'>
          <rect width='227.56' height='7.33' fill='white' transform='translate(142 70)' />
        </clipPath>
      </defs>
    </BaseIllustration>
  );
}

export default ExternalLinkIllustration;
